<style lang="scss" scoped>
.app-layout {
  min-height: 100%;

  &__header {
    backdrop-filter: blur(8px);
    background-color: rgb(255, 255, 255, 50%);
    padding: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2000;
  }

  &__main {
    overflow-y: hidden;
    padding: 0;

    &-box {
      min-height: 100%;
    }
  }

  .bg-image {
    background-image: url('./images/tu-xia@2x.png');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% 1000px;
  }

  &__help {
    position: fixed;
    right: 18px;
    top: 68%;
    transform: translateY(-50%);
    z-index: 10000;

    .geely-ai {
      position: absolute;
      right: 2px;
      top: -150px;
      z-index: 10000;
    }
  }
}
</style>
<template>
  <el-container class="app-layout">
    <el-header v-if="show" class="app-layout__header" :height="'60px'">
      <app-header></app-header>
    </el-header>
    <el-main
      class="app-layout__main"
      :class="{ 'bg-image': pageHeight }"
      ref="elMain"
    >
      <div
        class="app-layout__main-box"
        ref="box"
        :style="{ 'min-height': '900px' }"
      >
        <slot name="main"></slot>
      </div>
      <app-footer v-if="show" ref="elFooter"></app-footer>
    </el-main>
    <div class="app-layout__help">
      <geelyAI class="geely-ai"></geelyAI>
      <app-help></app-help>
    </div>
  </el-container>
</template>
<script>
import appHeader from '@/views/components/header';
import appFooter from '@/views/components/footer';
import appHelp from '@/views/components/help';
import geelyAI from '@/views/components/geely-ai/index.vue';
import robotE from '@/views/components/robot-e/index.js';

export default {
  name: 'appLayout',
  mixins: [robotE],
  components: {
    appHeader,
    appFooter,
    appHelp,
    geelyAI
  },
  data() {
    return {
      show: true
    };
  },
  computed: {
    pageHeight() {
      return this.$store.state.global.pageHeight;
    }
  },
  mounted() {
    if (window.__POWERED_BY_QIANKUN__) {
      this.show = false;
    }
  }
};
</script>
